// Format a string date to short date as given example: 'Jan, 01, 1970'
export const FormatDate = (aDate: string): string => {
    if (aDate) {
      const date = new Date(aDate);
      return date.toLocaleString("en-us", {
        day: "2-digit",
        month: "short",
        year: "numeric",
      });
    } else {
      return "";
    }
  };